import React from 'react';

import { useHistory } from 'react-router-dom';

import { useI18n } from 'Hooks';
import MegaToggle from 'Scenes-redesign/PIM/Components/MegaToggle';

import { DisabledFeatureTitle, DisabledFeatureWrapper } from './styles';

interface Props {
  feature: string;
}

const DisabledFeature = ({ feature }: Props) => {
  const history = useHistory();
  const { t } = useI18n();

  return (
    <>
      <DisabledFeatureWrapper>
        <DisabledFeatureTitle>{feature}</DisabledFeatureTitle>
        {feature} {t('General.FeatureDisabledForCompany')}
      </DisabledFeatureWrapper>
      {feature === 'POS' && (
        <MegaToggle
          items={['PIM', 'POS']}
          activeItem="POS"
          onSelect={() => history.push('/pim/articles')}
        />
      )}
    </>
  );
};

export default DisabledFeature;
